// src/api/billing.js
//
// F5 - Autogestion de la suscripcion Stripe del comprador web (portal de la
// institucion). Solo devuelve datos para instituciones compradas por Stripe;
// las altas manuales reciben hasStripeSubscription:false y el portal no
// muestra nada.

import { ENV } from "../Utils";

export class BillingApi {
  baseApi = ENV.BASE_API;

  async #request(accessToken, path, method = "GET") {
    const response = await fetch(`${this.baseApi}/${path}`, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  getMySubscription(accessToken) {
    return this.#request(accessToken, "billing/subscription");
  }

  cancelSubscription(accessToken) {
    return this.#request(accessToken, "billing/subscription/cancel", "POST");
  }

  reactivateSubscription(accessToken) {
    return this.#request(
      accessToken,
      "billing/subscription/reactivate",
      "POST",
    );
  }
}
